import LoadingContainer from './LoadingContainer.vue'
import LoadingDots from './LoadingDots.vue'
import LoadingSkeleton from './LoadingSkeleton.vue'

export default {
    'tl-loading-container': LoadingContainer,
    'tl-loading-dots': LoadingDots,
    'tl-loading-skeleton': LoadingSkeleton,
}
